import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { Chart, ChartPoint } from 'chart.js';
import moment from 'moment-timezone';
import { DataType, DataTypeComponent } from '../../../data-type-component';
import { DateRangeDTO, FieldConfigDTO } from '../../../../../../system/system-dtos';

interface ChartDatasetContentDTO {
  label: string;
  points: ChartPoint[];
}

interface ChartDataDO {
  name: string;
  title: string;
  content: ChartDatasetContentDTO[];
}

Chart.defaults.global.elements.point.radius = 0;

@Component({
  selector: 'app-graph-form-field',
  templateUrl: './graph-form-field.component.html',
  styleUrls: ['./graph-form-field.component.scss'],
  standalone: false,
})
export class GraphFormFieldComponent extends DataTypeComponent implements OnInit {
  @Input() data: any[];

  @Input() editMode: boolean;

  @Input() fieldConfig: FieldConfigDTO;

  @Input() formGroup: UntypedFormGroup;

  public chartCode: string;

  public chartTitle: string;

  public chart: Chart;

  public loading = true;

  public dateRangeFieldConfig: FieldConfigDTO;

  public form: UntypedFormGroup;

  private graphData: ChartDataDO;

  constructor(private formBuilder: UntypedFormBuilder) {
    super();
    this.dateRangeFieldConfig = {
      name: 'date_range',
      label: 'Date range',
      type: DataType.date_range,
    };
  }

  ngOnInit(): void {
    this.chartCode = this.fieldConfig.propertyName;
    this.form = this.formBuilder.group({
      date_range: {
        from: moment().subtract(1, 'days').toString(),
        to: moment().add(1, 'days').toString(),
      },
    });

    this.form.valueChanges.subscribe((c) => {
      if (this.chart) {
        this.updateChart(this.graphData, false);
      }
    });
  }

  private updateChart(graphData: ChartDataDO, onInit: boolean = true) {
    this.graphData = graphData;
    for (let i = 0; i < this.chart.data.datasets.length; i++) {
      const graphDatasetContentDTO = graphData.content[i];
      const points = graphDatasetContentDTO.points || [];
      points.forEach((p) => (p.x = new Date((p as any).x)));
      this.chart.data.datasets[i].data = this.getFiltered(points);
    }

    if (onInit) {
      this.chart = new Chart(this.chartCode, this.chart);
    } else {
      this.chart.update();
    }
  }

  private getFiltered(points: Chart.ChartPoint[]): Chart.ChartPoint[] {
    const dateRange: DateRangeDTO = this.form.get('date_range').value;
    if (!dateRange) {
      return points;
    }
    return points.filter((cp) => moment(cp.x).isBetween(moment(dateRange.from), moment(dateRange.to)));
  }
}
